import { DropIcon } from "../../_components/Imagepath";
import { Form, Field } from "react-final-form";

const AddProductForm = ({ id }) => {
  const onSubmit = (values) => {
    let payload = { ...values };
    if (values.document && values.document[0]) {
      payload = { ...payload, file: values.document[0] };
    } else {
      const { ...rest } = payload;
      payload = rest;
    }
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (key === "file" && value) {
        formData.append(key, value);
      } else if (key !== "image") {
        formData.append(key, value);
      }
    });

    const url = `/customers/${id}/documents`;
    const method = "POST";
    fetch(url, {
      method,
      body: formData,
      credentials: "include",
      headers: {
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
    })
      .then((res) => res.json())
      .then(() => {
        window.location.href = `/customers/${id}/documents/view`;
      })
      .catch((err) => {
        console.error("Error adding product:", err);
      });
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{}}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="input-block mb-3">
              <label>
                Document Name <span className="text-danger"> *</span>
              </label>
              <Field
                name="name"
                component="input"
                type="text"
                className="form-control"
                placeholder="Enter Product Name"
                required
              />
            </div>
          </div>

          <div className="form-group-item">
            <div className="row">
              <div
                className="col-xl-6 col-lg-6 col-md-6 col-12"
                style={{ marginLeft: "13px" }}
              >
                <div className="input-block mb-3">
                  <label>Document*</label>
                  {values.document ? (
                    <div className="input-block mb-3 service-upload mb-0 ml-2">
                      {values?.document[0]?.name}
                      <span
                        className="text-primary ms-1"
                        onClick={() => form.change("document", null)}
                        style={{ cursor: "pointer" }}
                      >
                        Remove
                      </span>
                    </div>
                  ) : (
                    <div className="input-block mb-3 service-upload mb-0">
                      <span>
                        <img src={DropIcon} alt="upload" />
                      </span>
                      <h6 className="drop-browse align-center">
                        Drop your files here or
                        <span className="text-primary ms-1">browse</span>
                      </h6>
                      <p className="text-muted">Maximum size: 10MB</p>
                      <Field name="document">
                        {({ input }) => {
                          console.log(input.value);
                          return (
                            <input
                              type="file"
                              multiple
                              id="image_sign"
                              onChange={(e) => input.onChange(e.target.files)}
                            />
                          );
                        }}
                      </Field>
                      <div id="frames" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-end">
            <button
              type="button"
              className="btn btn-primary cancel me-2"
              onClick={form.reset}
              disabled={submitting || pristine}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              {"Add Document"}
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default AddProductForm;
